// action
import {
    DELETE_COUPON,
    DELETE_COUPON_FAIL,
    DELETE_COUPON_SUCCESS,
    DELETE_COUPON_RESET
} from '../action/deleteCouponAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_COUPON:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_COUPON_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_COUPON_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_COUPON_RESET:
            return initialState
        default:
            return state
    }
}